import { GatewayTranslator } from './../translators/gateway_translator';
import { IGatewayDataManager, ISavConfig, ISearchConfig, IPhotosConfig, ISAVConfig } from "./iphoto_data_manager";
import { ITranslator, ITabViewTranslator } from "../translators/itranslator";
import { IClientConfig } from "../data_manager/data_manager_factory";
import { Util } from "../../common_utils/util";
import { AjaxHelper } from "../../http/ajax_helper";

export class GatewayPhotoDataManager implements IGatewayDataManager {
    private translator: ITabViewTranslator;
    private discoveryEndPoints: any;

    constructor(config: IClientConfig) {
      this.translator = new GatewayTranslator();
      this.discoveryEndPoints = config.discoveryEndPoints;
    }
    /**
     * Method is use to get the user select source album photos
     * @param config 
     */
    getSingleAlbumPhotos(config: ISavConfig) {
        var url = `/v1/gw/album/${config.albumId}/images?source=${config.source}&size=${config.size}`;
        
        if(config.pageToken){
            url +=`&pageToken=${config.pageToken}`
        }
        let reqConfig = {
            url: this.discoveryEndPoints.libraryService + '/request_api',
            type: "POST",
            data: JSON.stringify({uriTemplate: `/v1/gw/album/{albumId}/images/`,version: "v1", type: "GET", req_service: "pascal", url: url }),
            ignoreAToken: true,
            ignoreResCaching: true,
            cache:true
          };
          const promise =  AjaxHelper.triggerApi(
            {requestConfig: reqConfig},this.translator.translateClusterAssets.bind(this.translator,config))
          return promise; 
    }
    /**
     * Method used to return user selected filter photos
     * @param config 
     */
    getPhotosBySearch(config: ISearchConfig) {
        var url = `/v1/gw/images/filter?source=${config.source}&size=${config.size}`;
        if(config.contentFilter){
            var filter = config.contentFilter.toLowerCase();
            if(filter === "favorites"){
              url += `&favorites=true`
            }else{
              url += `&contentFilter=${filter}`
            }            
        }
        if(config.startYear && config.startMonth && config.startDay &&
           config.endYear && config.endMonth && config.endDay){
            url += `&startYear=${config.startYear}&startMonth=${config.startMonth}&startDay=${config.startDay}&endYear=${config.endYear}&endMonth=${config.endMonth}&endDay=${config.endDay}`
        }
        if(config.pageToken){
            url +=`&pageToken=${config.pageToken}`
        }
        let reqConfig = {
            url: this.discoveryEndPoints.libraryService + '/request_api',
            type: "POST",
            data: JSON.stringify({uriTemplate: `/v1/gw/images/filter`,version: "v1", type: "GET", req_service: "pascal", url: url }),
            ignoreAToken: true,
            ignoreResCaching: true,
            cache:true            
          };
          const promise =  AjaxHelper.triggerApi(
            {requestConfig: reqConfig},this.translator.translateClusterAssets.bind(this.translator,config))
          return promise;
        
    }
    /**
     * Method used to return the user selected source photos
     * @param config 
     */
    getAllPhotos(config: IPhotosConfig) {
        var url = `/v1/gw/images?source=${config.source}&size=${config.size}`
        if(config.pageToken){
            url +=`&pageToken=${config.pageToken}`
        }
        let reqConfig = {
            url: this.discoveryEndPoints.libraryService + '/request_api',
            type: "POST",
            data: JSON.stringify({uriTemplate: `/v1/gw/images`,version: "v1", type: "GET", req_service: "pascal", url: url }),
            ignoreAToken: true,
            ignoreResCaching: true,
            cache:true
          };
          const promise =  AjaxHelper.triggerApi(
            {requestConfig: reqConfig},this.translator.translateClusterAssets.bind(this.translator,config))
          return promise;
    }
    /**
     * Method is used to return user single album information
     * @param config 
     */
    getSingleAlbumInfo(config: ISAVConfig){
      var url = `/v1/gw/album/${config.albumId}?source=${config.source}`
      let reqConfig = {
        url: this.discoveryEndPoints.libraryService + '/request_api',
        type: "POST",
        data: JSON.stringify({uriTemplate: `/v1/gw/album/{albumId}`,version: "v1", type: "GET", req_service: "pascal", url: url }),
        ignoreAToken: true,
        ignoreResCaching: true,
        cache:true
      };
      const promise =  AjaxHelper.triggerApi(
        {requestConfig: reqConfig},this.translator.translateSingleAlbum.bind(this.translator)
      )
      return promise;      
    }
    /**
     * Method is going to get google content filter list
     */
    getGoogleContentFilters(){
      var url = '/v1/gw/contentFilters?source=google';
      let reqConfig = {
        url: this.discoveryEndPoints.libraryService + '/request_api',
        type: "POST",
        data: JSON.stringify({uriTemplate: `/v1/gw/contentFilters`,version: "v1", type: "GET", req_service: "pascal", url: url }),
        ignoreAToken: true,
        ignoreResCaching: true,
        cache:true
      };
      const promise =  AjaxHelper.triggerApi({ requestConfig: reqConfig});      
      return promise;
    }

}